// theirs
import React from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'

// ours
import { ContentDataModel } from '../../../interfaces'
import { introStatementBaseClass, StyledIntroStatement } from './style'
import {
    appendLocationMultiple,
    appendLocationSingle,
    appendSizes,
} from '../../../utils/append-location'
import { CollectionContext, CollectionContextInterface } from '../../../App'
import { animationVariants } from '../../../animations'

export interface IntroStatementProps {
    className?: string
    testId?: string
    content: ContentDataModel
    collectionContext?: CollectionContextInterface
    animationControls?: any
}

const IntroStatement = ({
    className,
    testId,
    content,
    animationControls,
}: IntroStatementProps) => {
    const collectionContext = React.useContext(CollectionContext)
    return (
        <StyledIntroStatement
            className={classNames(introStatementBaseClass, className)}
            data-testid={testId}
            content={content}
            collectionContext={collectionContext || undefined}
        >
            {content.contentTitle && (
                <motion.div
                    initial="hidden"
                    animate={animationControls}
                    variants={animationVariants.mainTitle}
                    className="title-wrapper"
                >
                    <h2
                        className="text"
                        dangerouslySetInnerHTML={{
                            __html: content.contentTitle,
                        }}
                    />
                </motion.div>
            )}
            {content.contentPicture && (
                <motion.div
                    
                    className={`image-wrapper in-view`}
                >
                    <motion.div
                        initial="hidden"
                        animate={animationControls}
                        variants={animationVariants.mainTitleImage}
                    >
                        {content.contentPicture.map((picture, index) => (
                            <picture
                                key={index}
                                className={picture.contentPictureClass}
                                data-testid={picture.contentPictureTestId}
                            >
                                <img
                                    src={appendLocationSingle(
                                        'images',
                                        picture.contentPictureImageSource
                                    )}
                                    alt={picture.contentPictureImageAlternateText}
                                    {...(picture.contentPictureSource && {
                                        srcSet: appendLocationMultiple(
                                            'images',
                                            picture.contentPictureSource
                                        ),
                                        sizes: appendSizes(
                                            picture.contentPictureSource
                                        ),
                                    })}
                                />
                            </picture>
                        ))}
                    </motion.div>
                </motion.div>
            )}
            {content.contentHelpText && (
                <div className="help-text-wrapper">
                    <motion.div
                        initial="hidden"
                        animate={animationControls}
                        variants={animationVariants.scrollExplore}
                        className="help-text"
                    >
                        {content.contentHelpText}
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        animate={animationControls}
                        style={{ originY: 0 }}
                        variants={animationVariants.verticalLine}
                        className="vertical-line"
                    />
                </div>
            )}
        </StyledIntroStatement>
    )
}

export default IntroStatement
